module.exports = __webpack_public_path__ + "static/media/logo.7ff4361c.png";